export const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};

export const THEMES = {
    DARK: 'dark',
};
